const showOverlay = () => {
  let overlayLayer = document.getElementById('kariba_overlay_container')
  overlayLayer.className = 'show-class'
}

export const hideMinimized = () => {
  let minimized = document.getElementById('kariba_random_gift_minimize')
  minimized.className = 'hide-class'
}

export const generateDefautPage = ({ mainPopup, minimize }) => {
  const backgroundUrl = mainPopup?.background?.url || ''
  const minimizeTitle = minimize?.text?.content || ''
  const titleStyle = minimize?.text?.style || {}
  const html = `
  <div id="kariba_random_gift_minimize" class="hide-class"
    style="background: url(${minimize?.background?.url || ''}) no-repeat;
      background-color:#F0F5FF;
      background-size: cover;
      background-position: center;">
      <span
      style="font-family: ${titleStyle.fontFamily || 'Inter'}; 
        color: ${titleStyle.color || '#FA541C'};
        font-size: ${titleStyle.fontSize || 14}px;
        font-weight: ${titleStyle.fontStyle || 'bold'};"
      >${minimizeTitle}</span>
  </div>
  <div id="kariba_overlay_container">
    <div id="kariba_random_gift" class="show-class"
      style="background: url(${backgroundUrl}) no-repeat;
      background-size: cover;
      background-position: center;
      align-items: center;
      justify-content: center;"
    >
      <div id="kariba_input_container"></div>
    </div>
  </div>`

  document.body.innerHTML += html

  let minimizeButton = document.getElementById('kariba_random_gift_minimize')
  minimizeButton.addEventListener('click', () => {
    showOverlay()
    hideMinimized()
  })
}
